<p-toolbar>
  <div class="p-toolbar-group-left flex align-items-center w-full gap-8">
    <!-- Left side filters in their own flex container -->
    <div class="flex gap-2" style="flex: 1;">
      <!-- Driver Search -->
      <div class="p-inputgroup flex-1">
        <span class="p-inputgroup-addon">
          <i class="pi pi-search"></i>
        </span>
        <p-autoComplete [(ngModel)]="selectedDriver" [suggestions]="filteredDrivers"
          (completeMethod)="filterDriver($event)" (onKeyUp)="onEnter($event)" field="label" [style]="{'width': '100%'}"
          (onSelect)="onSelect($event)" [showClear]="true" (onClear)="onClear()" [forceSelection]="false"
          [autoHighlight]="true" [delay]="0" [minLength]="1" [unique]="true" placeholder="Search Driver, Pickup # or Receiver"
          (dragover)="$event.preventDefault()" (drop)="$event.preventDefault()">
          <ng-template let-item pTemplate="item">
            <div class="flex align-items-center">
              <ng-container *ngIf="item.type === 'driver'">
                <i class="pi pi-user mr-2"></i>
                <span>{{ item.label }}</span>
              </ng-container>
              <ng-container *ngIf="item.type === 'pickup'">
                <i class="pi pi-ticket mr-2"></i>
                <span>{{ item.label }}</span>
              </ng-container>
              <ng-container *ngIf="item.type === 'receiver'">
                <i class="pi pi-building mr-2"></i>
                <span>{{ item.label }}</span>
              </ng-container>
            </div>
          </ng-template>
        </p-autoComplete>
      </div>

      <!-- Availability Filter -->
      <div class="p-inputgroup flex-1">
        <span class="p-inputgroup-addon">
          <i class="pi pi-users"></i>
        </span>
        <p-dropdown [(ngModel)]="selectedStatus" [options]="statusOptions" placeholder="Select Status"
          [style]="{ 'width': '100%' }" (onChange)="onFilter($event)">
        </p-dropdown>
      </div>
    </div>

    <!-- Dispatch Mode Toggle -->
    <div class="flex align-items-center gap-2 ml-3 mr-6">
      <span class="font-bold">Overview</span>
      <p-inputSwitch [(ngModel)]="sidebarVisible" (ngModelChange)="onSidebarChange()">
      </p-inputSwitch>
      <span class="font-bold">Dispatch</span>
    </div>
  </div>
</p-toolbar>

<!-- Sidebar -->
<p-sidebar [(visible)]="sidebarVisible" position="right" [baseZIndex]="10000" [style]="{ width: '560px' }"
  [modal]="false" (onHide)="onSidebarHide()">

  <app-drag-and-drop #dragAndDrop [driverCards]="driverCards"
    (orderAssigned)="onOrderAssigned($event)"
    (orderUnassigned)="onOrderUnassigned()">
  </app-drag-and-drop>

</p-sidebar>